export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.27-1132.12",
  commitId: "b2dd0affb2852db9fceebd2829e939bee2549424",
  commitTime: "2026-07-27T11:32:12.000Z",
});
